export const UsersEndpoints = {
    basePath: '',
    endpoints: {
        all: {
            path: '/users',
            method: 'GET',
            auth: true,
            get: null,
            fallback: [],
            swrOptions: {
                revalidateOnFocus: false
            }
        },
        getUserDetail: {
            path: '/users/{{id}}',
            method: 'GET',
            auth: true,
            get: null,
            fallback: null,
        },
        addUserDetail: {
            path: '/users',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        setRole: {
            path: '/users/role',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        setStatus: {
            path: '/users/state',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        updateUserDetail: {
            path: '/users/{{id}}',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
        },
        deleteUserDetail: {
            path: '/users/{{id}}',
            method: 'DELETE',
            auth: true,
            get: null,
            fallback: null,
        },
        registrationConfirm: {
            path: '/users/_confirm/{{t}}',
            method: 'GET',
            get: null,
            fallback: null,
        },
        reset: {
            path: '/users/passwords/reset',
            method: 'POST',
            auth: false,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        changePassword: {
            path: '/users/passwords/_change/{{t}}',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        changePasswordUser: {
            path: '/users/passwords/change/{{user_id}}',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        resendEmail: {
            path: '/users/resend-confirm',
            method: 'POST',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
        setConfirm: {
            path: '/users/confirm',
            method: 'PUT',
            auth: true,
            get: null,
            fallback: null,
            swr: {
                revalidateOnFocus: false
            }
        },
    }
}

export default UsersEndpoints;
